import React from 'react';
import { Label } from '@fluentui/react-components';

const LabelShimInternal = React.forwardRef((props, _ref) => (
  <Label ref={_ref} {...props} />
));

export const LabelShim = LabelShimInternal;
